import { getBorderRadius as getInaccessibleLightBorderRadius } from './borderRadius/themes/InaccessibleLight/alias';
import { getBorderStyle as getInaccessibleLightBorderStyle } from './borderStyle/themes/InaccessibleLight/alias';
import { getBorderWidth as getInaccessibleLightBorderWidth } from './borderWidth/themes/InaccessibleLight/alias';
import { getBorderWidth as getLightBorderWidth } from './borderWidth/themes/Light/alias';
import { getOutlineOffset as getInaccessibleLightOutlineOffset } from './outlineOffset/themes/InaccessibleLight/alias';
import { getOutlineStyle as getInaccessibleLightOutlineStyle } from './outlineStyle/themes/InaccessibleLight/alias';
import { getOutlineWidth as getInaccessibleLightOutlineWidth } from './outlineWidth/themes/InaccessibleLight/alias';
export function getBorderRadius(transformer, config) {
    return getInaccessibleLightBorderRadius(transformer);
}
export function getBorderStyle(transformer, config) {
    return getInaccessibleLightBorderStyle(transformer);
}
export function getBorderWidth(transformer, config) {
    if (config.getTheme() === 'Light') {
        return getLightBorderWidth(transformer);
    }
    if (config.getTheme() === 'Dark' &&
        config.getFeatureFlags().useAccessibleLightTheme.isEnabled()) {
        return getLightBorderWidth(transformer);
    }
    return getInaccessibleLightBorderWidth(transformer);
}
export function getOutlineOffset(transformer, config) {
    return getInaccessibleLightOutlineOffset(transformer);
}
export function getOutlineStyle(transformer, config) {
    return getInaccessibleLightOutlineStyle(transformer);
}
export function getOutlineWidth(transformer, config) {
    return getInaccessibleLightOutlineWidth(transformer);
}
